<!--
TELA PARA INCLUSÃO/ALTERAÇÃO DE ITEM NA NOTA DE SAIDA
-->


<script>
import { SysVars } from '../main';
import nfItem from '../api/api-nf-item.js'
import ItemForm from './item-form'

export default {
  props: {
    params: {},  //nfit: objeto, optSimples: false, nfAjuste: false, nfComplemento: false, habilitaItem: true
  },

  components: {
    ItemForm,
  },

  data() {
    return {
      nfit: {},
      //metadata: this.$store.getters.getEntities.metadata,
      local_metadata: { ...this.$store.getters.getEntities.metadata.nfit },
      tributadoIcm: false,
      informaMotdes: false,
      icmDiferido: false,
      habilitaBCIcm: false,
      habilitaAIcm: false,
      tributadoIcmST: false,
      tributadoIpi: false, //habilita ipi
      tributadoPis: false, //habilita pis
      informaFCI: false,   //habilita nr do fci conforme origem da mercadoria
      pautaPis: false,
      tributadoCofins: false,
      pautaCofins: false,
      tributadoPisST: false,
      tributadoCofinsST: false,
      creditoSN: false,   //habilita % credito icms simples nacional
      icmsRetido: false,
      unWatch: false,
      descricaoNovoItem: '',
      showIBSCBS: true,
      tipoVinculo: 'sistema',
      xmlParsedData: null,
      tabs: [
        { title: "Dados do Item (Principal)", icon: "" },
        { title: "Documento Fiscal de Origem (Rastreabilidade)", icon: "" }
      ],
      activeTab: 0,
      subTabs: [
        { title: "Nota do Sistema", icon: "" },
        { title: "Carregar XML", icon: "" },
        { title: "Digitação Manual", icon: "" }
      ],
      activeSubTab: 0,
      nfOrigemDados: null,
      nfitemOrigemDados: null,

      errmessages: [],
      crud: '',
      showItemForm: false
    }
  },

  mixins: [nfItem],

  computed: {
    isView: function () {
      return this.params.isView == true
    },
    isAjusteCreditoDebito() {
      return this.params.nf && (this.params.nf.tpnf === 'CR' || this.params.nf.tpnf === 'DB');
    },
    showLegacyTaxes() {
      if (this.isAjusteCreditoDebito) {
        return this.params.nf.tpnf === 'CR' && this.params.nf.tpnfcredito === '03';
      }
      return true;
    },
    coditem: function () {
      return this.nfit.coditem
    },
    selectedItem: function () {
      return this.$store.getters.getItem
    },
    itemTaxes: function () {
      return this.$store.getters.getItemTaxes
    },
    sticm() {
      return this.nfit.sticm
    },
    stipi() {
      return this.nfit.stipi
    },
    stpis() {
      return this.nfit.stpis
    },
    stcofins() {
      return this.nfit.stcofins
    },
    csosn() {
      return this.nfit.csosn
    },
    sticmentrada() {
      return this.nfit.sticmentrada
    },
    orimerc() {
      return this.nfit.orimerc
    },
    nfImportacao: function () {
      return (this.params.nfImportacao)
    },
    ivaclass: function () {
      return this.$store.getters.getivaclass
    },
    xmlSelectOptions() {
      if (!this.xmlParsedData || !this.xmlParsedData.itens) return [];
      return this.xmlParsedData.itens.map(item => ({
        id: item.nItem,
        text: item.descricao
      }));
    }
    // tributadoIcmST () {
    //     return (this.nfit.sticm == '10' || this.nfit.sticm == '30' || this.nfit.sticm == '70' || this.nfit.sticm == '90')
    // }

  },

  methods: {

    onXMLFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const xmlText = e.target.result;
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlText, "application/xml");

          const infNFe = xmlDoc.getElementsByTagName("infNFe")[0];
          let chave = "";
          if (infNFe && infNFe.getAttribute("Id")) {
            chave = infNFe.getAttribute("Id").replace("NFe", "");
          } else {
            const chNFe = xmlDoc.getElementsByTagName("chNFe")[0];
            if (chNFe) chave = chNFe.textContent;
          }

          if (chave.length !== 44) {
            this.$erpToastError("Não foi possível identificar uma Chave de Acesso válida de 44 dígitos neste XML.");
            return;
          }

          const detElements = xmlDoc.getElementsByTagName("det");
          const itensXml = [];
          for (let i = 0; i < detElements.length; i++) {
            const det = detElements[i];
            const nItem = det.getAttribute("nItem");
            const prod = det.getElementsByTagName("prod")[0];
            const xProd = prod ? prod.getElementsByTagName("xProd")[0].textContent : "";
            const qCom = prod ? parseFloat(prod.getElementsByTagName("qCom")[0].textContent) : 0;
            const vUnCom = prod ? parseFloat(prod.getElementsByTagName("vUnCom")[0].textContent) : 0;

            itensXml.push({
              nItem: nItem,
              descricao: `Item ${nItem} - ${xProd} (Qtd: ${qCom} / R$ ${vUnCom.toFixed(2)})`
            });
          }

          this.xmlParsedData = {
            chave: chave,
            itens: itensXml
          };

        } catch (err) {
          this.$erpToastError("Erro ao processar o arquivo XML: " + err.message);
        }
      };
      reader.readAsText(file);
    },

    selecionarItemXml(item) {
      if (!item) return;
      this.nfit.chaveorigem = this.xmlParsedData.chave;
      this.nfit.nitemorigem = item.nItem;
      this.nfit.codnforigem = "";
      this.nfit.codnfitorigem = "";
    },

    limparVinculoOrigem() {
      this.nfit.codnforigem = "";
      this.nfit.codnfitorigem = "";
      this.nfit.chaveorigem = "";
      this.nfit.nitemorigem = "";
      this.xmlParsedData = null;
      this.nfOrigemDados = null;
      this.nfitemOrigemDados = null;
      this.$erpToastSuccess("Vínculo de origem removido.");
    },

    async loadivaclass() {
      //carrega o registro para alteracao ou visualizacao
      await this.$store.dispatch('loadivaclass', { id: this.nfit.ibscbscclass })
    },


    handleCadastroItem(text) {
      //abre tela para cadastro de novo produto
      this.crud = SysVars.crudI
      this.descricaoNovoItem = text
      this.showItemForm = true
    },

    closeItemForm(item) {
      //ao fechar o formulario de cadastro de produto
      this.showItemForm = false
      if (item) {
        this.nfit.coditem = item.coditem
      }
    },

    handleNewItem(selectedItem) {
      if (!selectedItem) return
      this.nfit.coditem = selectedItem.coditem
    },

    handleSalvar() {
      //botao salvar item
      var param = []
      param.push(this.nfit)
      this.$emit('save', param)
    },

    habilitaTributacaoIcms() {
      let sticm = null
      if (this.nfit.sticmentrada)
        sticm = this.nfit.sticmentrada
      else
        if (this.params.optSimples)
          sticm = this.nfit.csosn
        else
          sticm = this.nfit.sticm

      this.habilitaBCIcm = (this.params.nfComplementar || sticm == '90' || sticm == '900')
      this.tributadoIcmST = (sticm == '10' || sticm == '30' || sticm == '70' || sticm == '90' || sticm == '201' || sticm == '202' || sticm == '203' || sticm == '900')
      // this.tributadoIcm = (sticm != '30' && sticm != '40' && sticm != '41' && sticm != '50' && sticm != '60')
      this.tributadoIcm = (sticm == '00' || sticm == '10' || sticm == '20' || sticm == '70' || sticm == '90' || sticm == '900')
      this.icmDiferido = (sticm == '51')
      this.icmsRetido = (sticm == '60' || sticm == '90' || sticm == '500' || sticm == '900')
      this.informaMotdes = (sticm == '20' || sticm == '70' || sticm == '40' || sticm == '41' || this.nfit.ricm > 0 || sticm == '90' || sticm == '900')
      this.creditoSN = ((sticm == '201' || sticm == '101'))
      this.habilitaAIcm = (this.tributadoIcm || sticm == '41' || sticm == '40' || sticm == '201' || sticm == '202' || sticm == '203')

    },

    changeTab(index) {
      this.activeTab = index;
    },

    changeSubTab(index) {
      this.activeSubTab = index;
      const mappings = ['sistema', 'xml', 'manual'];
      this.tipoVinculo = mappings[index];
    },

    selecionarItemXmlByValue(nItemValue) {
      if (!nItemValue) {
        this.nfit.nitemorigem = "";
        return;
      }
      if (!this.xmlParsedData) return;
      const item = this.xmlParsedData.itens.find(i => i.nItem === nItemValue);
      if (item) {
        this.selecionarItemXml(item);
      }
    },

    async apiFetchNfOrigem(codnforigem) {
      if (!codnforigem) {
        this.nfOrigemDados = null;
        this.nfitemOrigemDados = null;
        return;
      }
      try {
        await this.$store.dispatch('loadNf', { id: codnforigem });
        const nfList = this.$store.getters.getNf;
        if (nfList && nfList.length > 0) {
          const nf = nfList[0];
          this.nfOrigemDados = {
            chave: nf.chave || 'Não informada',
            serie: nf.serie,
            numnf: nf.nf
          };
          this.syncNfItemOrigemDados();
        } else {
          this.nfOrigemDados = null;
          this.nfitemOrigemDados = null;
        }
      } catch (err) {
        console.error(err);
        this.nfOrigemDados = null;
        this.nfitemOrigemDados = null;
      }
    },

    syncNfItemOrigemDados() {
      const codnfitorigem = this.nfit.codnfitorigem;
      if (!codnfitorigem || !this.$store.getters.getNf || this.$store.getters.getNf.length === 0) {
        this.nfitemOrigemDados = null;
        return;
      }
      const nf = this.$store.getters.getNf[0];
      if (nf.nfit && nf.nfit.length > 0) {
        const item = nf.nfit.find(i => i.codnfit === codnfitorigem);
        if (item) {
          this.nfitemOrigemDados = {
            descricao: (item.item && item.item.length > 0) ? item.item[0].descricao : 'Produto sem descrição',
            quantidade: item.qtuni,
            valor: item.vlr
          };
        } else {
          this.nfitemOrigemDados = null;
        }
      } else {
        this.nfitemOrigemDados = null;
      }
    },

    closeForm() {
      this.$emit('closeform')
    },

    handleValidation() {
      this.errmessages = []

      this.$validator.reset();

      //VALIDACAO DOS CAMPOS DE IMPOSTOS CONFORME SITUACAO TRIBUTARIA DE CADA IMPOSTO
      this.local_metadata.aicm.validator = {}
      this.local_metadata.ricm.validator = {}
      this.local_metadata.aicmst.validator = {}
      this.local_metadata.bcicm.validator = {}
      this.local_metadata.vicm.validator = {}
      this.local_metadata.bcicmst.validator = {}
      this.local_metadata.vicm.validator = {}
      this.local_metadata.aipi.validator = {}
      this.local_metadata.ripi.validator = {}
      this.local_metadata.vipi.validator = {}
      this.local_metadata.bcipi.validator = {}
      this.local_metadata.apis.validator = {}
      this.local_metadata.rpis.validator = {}
      this.local_metadata.apisst.validator = {}
      this.local_metadata.vpis.validator = {}
      this.local_metadata.bcpis.validator = {}
      this.local_metadata.acofins.validator = {}
      this.local_metadata.rcofins.validator = {}
      this.local_metadata.acofinsst.validator = {}
      this.local_metadata.vcofins.validator = {}
      this.local_metadata.bccofins.validator = {}
      this.local_metadata.bcicmretst.validator = { required: false }
      this.local_metadata.vicmretst.validator = { required: false }
      this.local_metadata.chaveorigem.validator = { required: false, digits: 44 }
      this.local_metadata.nitemorigem.validator = { required: false, numeric: true }
      this.local_metadata.codnforigem.validator = { required: false, numeric: true }
      this.local_metadata.codnfitorigem.validator = { required: false, numeric: true }
      this.local_metadata.vlr.validator = { required: true, "valida-zero": true }

      if (this.params.nfAjuste || this.params.nfComplementar) {
        this.local_metadata.ncm.validator = {}
        this.local_metadata.vlr.validator = {}
      }

      if (this.tributadoIcm) {
        this.local_metadata.aicm.validator = { required: true, "valida-zero": false }
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcicm.validator = { required: true, "valida-zero": false }
          this.local_metadata.vicm.validator = { required: true, "valida-zero": false }
        }
      }

      if (this.tributadoIcmST) {
        this.local_metadata.aicmst.validator = { required: true, "valida-zero": false }
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcicmst.validator = { required: true, "valida-zero": false }
          this.local_metadata.vicmst.validator = { required: true, "valida-zero": false }
        }
      }

      if (this.tributadoIpi) {
        this.local_metadata.aipi.validator = { required: true, "valida-zero": false }
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcipi.validator = { required: true, "valida-zero": false }
          this.local_metadata.vipi.validator = { required: true, "valida-zero": false }
        }
      }

      if (this.tributadoPis) {
        this.local_metadata.apis.validator = { required: true, "valida-zero": false }
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bcpis.validator = { required: true, "valida-zero": false }
          this.local_metadata.vpis.validator = { required: true, "valida-zero": false }
        }
      }

      if (this.tributadoCofins) {
        this.local_metadata.acofins.validator = { required: true, "valida-zero": false }
        if (this.params.nfAjuste || this.params.nfComplementar) {
          this.local_metadata.bccofins.validator = { required: true, "valida-zero": false }
          this.local_metadata.vcofins.validator = { required: true, "valida-zero": false }
        }
      }

      // console.log('passou aqui')
      // console.log(this.local_metadata.aicm.validator)
      // console.log(this.sticm)
      // console.log(this.nfit.sticm)
      if (this.sticm == '60' || this.sticm == '500') {
        // console.log('this.nfit.sticmentrada ' + this.nfit.sticmentrada)
        // console.log(this.tributadoIcm)
        // console.log(this.habilitaAIcm)
        this.local_metadata.bcicmretst.validator = { required: true, "valida-zero": true }
        this.local_metadata.vicmretst.validator = { required: true, "valida-zero": true }
      }
      // if (this.sticm == '20' || this.sticm == '70') {
      //     this.local_metadata.motdesicm.validator = { required: true }
      // }

    },
    handleValidarItem() {
      // this.handleValidation();
      if (!(this.params.nfAjuste || this.params.nfComplementar) && (this.nfit.vlr == 0)) {
        this.$erpToastError('Insira o valor do item')
        return;
      }

      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          if (((this.sticm == '60') || (this.sticm == '500')) && !(this.nfit.bcicmretst > 0)) {
            this.$erpToastError('Informe a Base do ICMS Retido Anteriormente.')
            return;
          }
          if (this.nfit.pdevol > 100) {
            this.$erpToastError('Quantidade devolvida acima da permitida')
            return;
          }
          if (!this.nfit.qtuni > 0) {
            this.$erpToastError('Insira a quantidade do item')
            return;
          }
          this.handleSalvar()
        }
      })

    },
    calculaImpostoDevol() {
      if (this.params.ipidevol) {
        if (this.nfit.codnfitorigem && this.nfit.codnfitorigem !== '') {
          this.nfit.pdevol = (this.nfit.qtuni / this.nfit.qtorigem) * 100;
          this.nfit.vipidevol = ((this.nfit.vipiorigem * this.nfit.pdevol) / 100);
        } else {
          if (!this.nfit.pdevol || this.nfit.pdevol === 0) {
            this.nfit.pdevol = 100;
          }
          this.nfit.vipidevol = (((this.nfit.bcipi || 0) * (this.nfit.aipi || 0)) / 100) * (this.nfit.pdevol / 100);
        }
      } else {
        this.nfit.pdevol = 0;
        this.nfit.vipidevol = 0;
      }
    }
  },

  watch: {
    'nfit.codnforigem': function (newVal) {
      this.apiFetchNfOrigem(newVal);
    },
    'nfit.codnfitorigem': function () {
      this.syncNfItemOrigemDados();
    },
    'nfit.stipi': function () {
      this.handleValidation()
    },
    'nfit.stpis': function () {
      this.handleValidation()
    },
    'nfit.stcofins': function () {
      this.handleValidation()
    },
    'nfit.sticm': function () {
      this.handleValidation()
    },
    'nfit.ibscbscclass': function () {
      this.loadivaclass()

      if (this.coditem != null) {
        //this.apiCarregaIvaclass(this.nfit)
      }
      this.handleValidation()
    },

    coditem: function () {
      //ao digitar um item, carrega os dados deste item
      if (this.unWatch) {
        this.unWatch = false
        return
      }


      if (this.coditem != null) {
        this.nfit.coditem = this.coditem
        this.nfit.operacaonf = this.params.nf.operacaonf

        this.apiCarregaProduto(this.nfit)

        this.handleValidation()

        //chamada de BO_NFS.GET_ITEM_TAXES para carga dos dados de impostos do item informado
        // this.$store.dispatch('loadItem', { id: this.coditem }).then(response => {
        //   console.log('response', this.selectedItem)
        // })
        // this.$store.dispatch('loadItemTaxes', { codnf: this.nfit.codnf, coditem: this.coditem, finalidade: this.nfit.finalidade })
      }
    },

    selectedItem: function () {
      //quando selecionar um item, carrega a unidade de medida, ncm e a origem da mercadoria
      if (this.unWatch) return

      if (!this.selectedItem.length) {
        return
      }



      //ESTE PROCESSO FOI SUBSTITUIDO PELO this.apiCarregaProduto



      // this.nfit.uni = this.selectedItem[0].uni
      // this.nfit.ncm = this.selectedItem[0].ncm
      // this.nfit.orimerc = this.selectedItem[0].orimerc
      // //agrega o objeto retornado pela API ao objeto NFIT
      // this.nfit.item = this.selectedItem
      // this.nfit.vlr = this.selectedItem[0].precovenda
    },

    itemTaxes: function () {
      //ao selecionar um item, carrega a os dados de impostos deste item
      if (this.unWatch) return

      if (!this.itemTaxes) {
        return
      }

      //ESTE PROCESSO FOI SUBSTITUIDO PELO this.apiCarregaProduto


      // this.nfit.nfci = this.itemTaxes.nfci
      // this.nfit.csosn = this.itemTaxes.csosn
      // this.nfit.sticm = this.itemTaxes.sticm
      // this.nfit.stpis = this.itemTaxes.stpis
      // this.nfit.stcofins = this.itemTaxes.stcofins
      // this.nfit.stipi = this.itemTaxes.stipi
      // this.nfit.cfop = this.itemTaxes.cfop
      // this.nfit.motdesicm = this.itemTaxes.motdesicm
      // this.nfit.cest = this.itemTaxes.cest
      // this.nfit.aicm = this.itemTaxes.aicm
      // this.nfit.ricm = this.itemTaxes.ricm
      // this.nfit.afcp = this.itemTaxes.afcp
      // this.nfit.aicmst = this.itemTaxes.aicmst
      // this.nfit.mva = this.itemTaxes.mva
      // this.nfit.pautaicm = this.itemTaxes.pautaicm
      // this.nfit.pautaicmst = this.itemTaxes.pautaicmst
      // this.nfit.ricmst = this.itemTaxes.ricmst
      // this.nfit.afcpst = this.itemTaxes.afcpst
      // this.nfit.picmdif = this.itemTaxes.picmdif

      // this.nfit.pdesicm = this.itemTaxes.pdesicm
      // this.nfit.pdespc = this.itemTaxes.pdespc

      // this.nfit.particmdest = this.itemTaxes.particmdest
      // this.nfit.aicmdest = this.itemTaxes.aicmdest
      // this.nfit.afcpdest = this.itemTaxes.afcpdest

      // this.nfit.aipi = this.itemTaxes.aipi
      // this.nfit.ripi = this.itemTaxes.ripi
      // this.nfit.pautaipi = this.itemTaxes.pautaipi
      // this.nfit.cenqipi = this.itemTaxes.cenqipi

      // this.nfit.apis = this.itemTaxes.apis
      // this.nfit.apisst = this.itemTaxes.apisst
      // this.nfit.rpis = this.itemTaxes.rpis
      // this.nfit.pautapis = this.itemTaxes.pautapis
      // this.nfit.pautapisst = this.itemTaxes.pautapisst

      // // this.nfit.atribest = this.itemTaxes.atribest
      // // this.nfit.atribfed = this.itemTaxes.atribfed
      // // this.nfit.atribimp = this.itemTaxes.atribimp
      // // this.nfit.atribmun = this.itemTaxes.atribmun

      // this.nfit.acofins = this.itemTaxes.acofins
      // this.nfit.acofinsst = this.itemTaxes.acofinsst
      // this.nfit.rcofins = this.itemTaxes.rcofins
      // this.nfit.pautacofins = this.itemTaxes.pautacofins
      // this.nfit.pautacofinsst = this.itemTaxes.pautacofinsst

      // this.nfit.stiss = this.itemTaxes.stiss
      // this.nfit.aiss = this.itemTaxes.aiss

      // this.nfit.bcicmsret
    },

    csosn: function () {
      this.habilitaTributacaoIcms()
    },

    sticmentrada: function () {
      this.habilitaTributacaoIcms()
    },

    sticm: function () {
      this.habilitaTributacaoIcms()
    },

    stipi: function () {
      this.tributadoIpi = (this.nfit.stipi == '50' || this.nfit.stipi == '99' || this.nfit.stipi == '00' || this.nfit.stipi == '49')
    },

    stpis: function () {
      this.tributadoPis = (this.nfit.stpis == '01' || this.nfit.stpis == '02' || this.nfit.stpis == '49' ||
        this.nfit.stpis == '50' || this.nfit.stpis == '98' || this.nfit.stpis == '99')
      this.tributadoPisST = (this.nfit.stpis == '05')
      this.pautaPis = (this.nfit.stpis == '03')
    },

    stcofins: function () {
      this.tributadoCofins = (this.nfit.stcofins == '01' || this.nfit.stcofins == '02' || this.nfit.stcofins == '49' ||
        this.nfit.stcofins == '50' || this.nfit.stcofins == '98' || this.nfit.stcofins == '99')
      this.tributadoCofinsST = (this.nfit.stcofins == '05')
      this.pautaCofins = (this.nfit.stcofins == '03')
    },

    orimerc: function () {
      this.informaFCI = (this.nfit.orimerc == '1' || this.nfit.orimerc == '2' || this.nfit.orimerc == '3' || this.nfit.orimerc == '8')
    },

    'params.ipidevol': function () {
      this.calculaImpostoDevol();
    },

    'nfit.qtuni': function () {
      this.calculaImpostoDevol();
    },

    'nfit.bcipi': function () {
      this.calculaImpostoDevol();
    },

    'nfit.aipi': function () {
      this.calculaImpostoDevol();
    },

    'nfit.pdevol': function () {
      this.calculaImpostoDevol();
    },

    novatributacao: function () {
      this.showIBSCBS = this.nfit.ibscbscclass != '' || this.nfit.ibsufaliq > 0 || this.nfit.ibsufred > 0 ||
        this.nfit.ibsmunaliq > 0 || this.nfit.ibsmunred > 0 || this.nfit.cbsaliq > 0 || this.nfit.cbsred > 0 ||
        this.nfit.ccredpres != '' || this.nfit.ibspcredpres > 0 || this.nfit.ibsvcredprescondsus > 0 ||
        this.nfit.cbspcredpres > 0 || this.nfit.cbsvcredprescondsus > 0 ||
        this.nfit.ibsamono > 0 || this.nfit.cbsamono > 0 || this.nfit.ibsamonoret > 0 ||
        this.nfit.cbsamonoret > 0 || this.nfit.ibsamonoreten > 0 || this.nfit.cbsamonoreten > 0 ||
        this.nfit.ibsamonodif > 0 || this.nfit.cbsamonodif > 0;
    }

  },

  mounted() {
  },

  created() {
    this.local_metadata.chaveorigem = this.local_metadata.chaveorigem || {
      label: 'Chave de Acesso Referenciada (44 dígitos)',
      validator: { required: false, digits: 44 }
    };
    this.local_metadata.nitemorigem = this.local_metadata.nitemorigem || {
      label: 'Nº do Item de Origem',
      validator: { required: false, numeric: true }
    };
    this.local_metadata.codnforigem = this.local_metadata.codnforigem || {
      label: 'ID da Nota de Origem (Sistema)',
      validator: { required: false, numeric: true }
    };
    this.local_metadata.codnfitorigem = this.local_metadata.codnfitorigem || {
      label: 'ID do Item de Origem (Sistema)',
      validator: { required: false, numeric: true }
    };
    this.local_metadata.xmlSelectedItem = this.local_metadata.xmlSelectedItem || {
      label: 'Selecione o Item da Nota Original',
      validator: { required: false }
    };

    if (this.params.nfit) {
      this.nfit = this.params.nfit
      if (this.nfit.codnforigem === null) this.nfit.codnforigem = '';
      if (this.nfit.codnfitorigem === null) this.nfit.codnfitorigem = '';
      if (this.nfit.chaveorigem === null) this.nfit.chaveorigem = '';
      if (this.nfit.nitemorigem === null) this.nfit.nitemorigem = '';
    }
    this.unWatch = true

    this.handleValidation()

    if (this.nfit.codnforigem) {
      this.apiFetchNfOrigem(this.nfit.codnforigem);
    }

    if (this.isAjusteCreditoDebito) {
      this.showIBSCBS = true
    }

    this.$nextTick(function () {
      if (this.$refs.item)
        this.$refs.item.focus()
    })

  }

}

</script>

<template>
  <transition>
    <div class="nb-modal-scrollable" v-if="!showItemForm">
      <div class="container nb-modal-scrollable-container">
        <div class="nb-modal-header">
          <h4 class="def-title">Item da Nota Fiscal</h4>
          <div class="ml-auto">
            <v-button v-if="!isView" ref="btnConfirm" label="Salvar (F9)" :nb-btdef="true" @click="handleValidarItem"></v-button>
            <v-button ref="btnClose" label="Cancelar" @click="closeForm"></v-button>
          </div>
          <button type="button" class="close ml-2" @click="closeForm()" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div id="mymodal" class="nb-modal-scrollable-body" @keydown.f9="handleValidarItem">
          <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab" class="mb-4"></tabs>

          <div v-show="activeTab === 0">
          <div class="row" v-if="!params.habilitaItem">
            <div class="col-md-3 col-1">
              <span class="lbl-title-produto w-100">{{ nfit.item[0].descricao }}</span>
              <span class="data-list w-100">{{ nfit.item[0].codigo }}</span>
            </div>
            <div class="col-md-1 col-2" align="center">
              <span class="lbl-title-produto w-100">{{ this.local_metadata.uni.label }}</span>
              <span class="data-list w-100">{{ this.nfit.uni }}</span>
            </div>
            <div class="col-md-2 col-3" align="right">
              <span class="lbl-title-produto w-100">{{ this.local_metadata.qtuni.label }}</span>
              <span class="data-list w-100">{{ this.nfit.qtuni | formatValue(2) }}</span>
            </div>
            <div class="col-md-2 col-4" align="right">
              <span class="lbl-title-produto w-100">{{ this.local_metadata.vlr.label }}</span>
              <span class="data-list w-100">{{ this.nfit.vlr | formatValue(2) }}</span>
            </div>
            <div class="col-md-2 col-5" align="right">
              <span class="lbl-title-produto w-100">{{ this.local_metadata.totliq.label }}</span>
              <span class="data-list w-100">{{ this.nfit.totliq | formatValue(2) }}</span>
            </div>
          </div>
          <!-- {{ errors }} -->
          <!-- permite informar dados do item para notas de remessa, devolução, retorno, transferencia -->
          <div id="item" v-if="params.habilitaItem">
            <div class="row">
              <div class="col-md-12 col-12">
                <v-label class="w-100" :metadata-field="local_metadata.coditem"></v-label>
                <div class="">
                  <input-item ref="item" v-model="nfit.coditem" :add-button="true" @onselect="handleNewItem"
                    :disabled="nfit.codpedv" @novo="handleCadastroItem"></input-item>
                </div>
              </div>
              <!-- <form-field v-model="nfit.coditem" type="select2" col="12" :metadata="local_metadata.coditem" :disabled="isView"
                        name="coditem" :v-errors="errors" v-validate="local_metadata.coditem.validator"></form-field> -->
            </div>
            <div class="row">
              <form-field v-model="nfit.qtuni" type="value" col="2" :metadata="local_metadata.qtuni"
                :disabled="(isView && params.habilitaItem) || nfit.codpedv" name="qtuni" :v-errors="errors"
                v-validate="local_metadata.qtuni.validator"></form-field>
              <form-field v-model="nfit.vlr" type="value" col="2" :metadata="local_metadata.vlr"
                :disabled="isView || nfit.codpedv" name="vlr" :v-errors="errors"
                v-validate="local_metadata.vlr.validator"></form-field>
              <form-field v-model="nfit.uni" :tabindex="1" type="select2" col="2" :metadata="local_metadata.uni"
                :disabled="isView || nfit.codpedv" parent="mymodal" name="uni" :v-errors="errors"
                v-validate="local_metadata.uni.validator"></form-field>
              <form-field v-model="nfit.totliq" type="value" col="2" :metadata="local_metadata.totliq"
                :disabled="isView" name="totliq" :v-errors="errors" v-validate="local_metadata.totliq.validator"
                v-if="params.nfComplementar"></form-field>

              <form-field v-model="nfit.indtot" type="select" col="3" :metadata="local_metadata.indtot"></form-field>
              <form-field v-if="(nfit.indtot != 'N')" v-model="nfit.inddup" type="select" col="3"
                :metadata="local_metadata.inddup"></form-field>

            </div>
          </div>
          <div class="row" id="ncm">
            <form-field v-model="nfit.ncm" type="select2" col="4" :metadata="local_metadata.ncm" :disabled="isView"
              parent="mymodal" name="ncm" :v-errors="errors" v-validate="local_metadata.ncm.validator"></form-field>
            <form-field v-model="nfit.orimerc" type="select2" col="4" :metadata="local_metadata.orimerc"
              :disabled="isView" name="orimerc" :v-errors="errors" v-validate="local_metadata.orimerc.validator"
              parent="mymodal"></form-field>
            <!-- CFOP ENTRADA -->
            <form-field v-if="!params.nfsaida" v-model="nfit.cfop" type="select2" col="4"
              :metadata="local_metadata.cfop" :disabled="isView" parent="mymodal"
              :select2="{ entity: 'cfop/entradas', minlength: 0 }"></form-field>
            <!-- CFOP SAIDA OBRIGATORIA -->
            <form-field v-if="params.nfsaida" v-model="nfit.cfop" type="select2" col="4" :metadata="local_metadata.cfop"
              :disabled="isView" parent="mymodal" :select2="{ entity: 'cfop/saidas', minlength: 0 }"></form-field>
            <form-field v-if="informaFCI" v-model="nfit.nfci" type="text" col="4" :metadata="local_metadata.nfci"
              :disabled="isView" name="nfci" :v-errors="errors" v-validate="local_metadata.nfci.validator"></form-field>
          </div>

          <!-- dados do item para notas de complemento de impostos -->
          <div id="complemento" v-if="params.nfComplementar">
          </div>

          <!-- dados do item para notas de ajuste (credito icms) -->
          <div id="ajuste" v-if="params.nfAjuste">
            <div class="row">
              <form-field v-model="nfit.vicm" type="value" col="2" :metadata="local_metadata.vicm" :disabled="isView"
                name="vicm" :v-errors="errors" v-validate="local_metadata.vicm.validator" v-if="params.nfComplementar">
              </form-field>
            </div>
          </div>
          <!-- alíquotas de impostos -->
          <div v-if="showLegacyTaxes">
            <div>
              <label-title title="ICMS"></label-title>
            <div class="row">
              <form-field v-if="params.nf.operacaonf == 'S' && !params.optSimples" v-model="nfit.sticm" type="select2"
                col="4" :metadata="local_metadata.sticm" :disabled="isView" parent="mymodal" name="sticm"
                :v-errors="errors" v-validate="local_metadata.sticm.validator"></form-field>
              <form-field v-if="params.nf.operacaonf == 'S' && params.optSimples" v-model="nfit.csosn" type="select2"
                col="4" :metadata="local_metadata.csosn" :disabled="isView" parent="mymodal" name="csosn"
                :v-errors="errors" v-validate="local_metadata.csosn.validator"></form-field>

              <form-field v-if="params.nf.operacaonf == 'E' && params.nf.emissaopropria == 'N'"
                v-model="nfit.sticmentrada" type="select2" col="4" :metadata="local_metadata.sticmentrada"
                :disabled="isView" parent="mymodal" name="sticm" :v-errors="errors"
                v-validate="local_metadata.sticm.validator"></form-field>
              <form-field v-if="params.nf.operacaonf == 'E' && params.nf.emissaopropria == 'S' && !params.optSimples"
                v-model="nfit.sticm" type="select2" col="4" :metadata="local_metadata.sticm" :disabled="isView"
                parent="mymodal" name="sticm" :v-errors="errors" v-validate="local_metadata.sticm.validator">
              </form-field>
              <form-field v-if="params.nf.operacaonf == 'E' && params.nf.emissaopropria == 'S' && params.optSimples"
                v-model="nfit.csosn" type="select2" col="4" :metadata="local_metadata.csosn" :disabled="isView"
                parent="mymodal" name="csosn" :v-errors="errors" v-validate="local_metadata.csosn.validator">
              </form-field>

              <div class="w-100"></div>
              <form-field v-model="nfit.bcicm" type="value" col="2" :metadata="local_metadata.bcicm" :disabled="isView"
                name="bcicm" :v-errors="errors" v-validate="local_metadata.bcicm.validator" v-if="habilitaBCIcm">
              </form-field>
              <!-- problema de validacao na sticm = 60
              <form-field v-model="nfit.aicm" type="value" col="2" :metadata="local_metadata.aicm" :disabled="isView"
                name="aicm" :v-errors="errors" v-validate="local_metadata.aicm.validator"
                v-if="habilitaAIcm"></form-field> -->
              <form-field v-model="nfit.aicm" type="value" col="2" :metadata="local_metadata.aicm" :disabled="isView"
                name="aicm" :v-errors="errors" v-if="habilitaAIcm"></form-field>
              <form-field v-model="nfit.ricm" type="value" col="2" :metadata="local_metadata.ricm" :disabled="isView"
                name="ricm" :v-errors="errors" v-validate="local_metadata.ricm.validator" v-if="tributadoIcm">
              </form-field>
              <form-field v-model="nfit.picmdif" type="value" col="2" :metadata="local_metadata.picmdif"
                :disabled="isView" name="picmdif" :v-errors="errors" v-validate="local_metadata.picmdif.validator"
                v-if="icmDiferido"></form-field>
              <form-field v-model="nfit.vicm" type="value" col="2" :metadata="local_metadata.vicm" :disabled="isView"
                name="vicm" :v-errors="errors" v-validate="local_metadata.vicm.validator" v-if="params.nfComplementar">
              </form-field>
              <form-field v-model="nfit.afcp" type="value" col="2" :metadata="local_metadata.afcp" :disabled="isView"
                name="afcp" :v-errors="errors" v-validate="local_metadata.afcp.validator" v-if="tributadoIcm">
              </form-field>
              <form-field v-model="nfit.vfcp" type="value" col="2" :metadata="local_metadata.vfcp" :disabled="isView"
                name="vfcp" :v-errors="errors" v-validate="local_metadata.vfcp.validator" v-if="params.nfComplementar">
              </form-field>
              <form-field v-model="nfit.pcredsn" type="value" col="2" :metadata="local_metadata.pcredsn"
                :disabled="isView" name="pcredsn" :v-errors="errors" v-validate="local_metadata.pcredsn.validator"
                v-if="creditoSN"></form-field>
              <!-- <form-field v-model="nfit.aicmretst" type="value" col="2" :metadata="local_metadata.aicmretst" :disabled="isView"
                        name="aicmretst" :v-errors="errors" v-validate="local_metadata.aicmretst.validator" v-if="icmsRetido"></form-field> -->

              <form-field v-model="nfit.bcicmretst" type="value" col="2" :metadata="local_metadata.bcicmretst"
                :disabled="isView" name="bcicmretst" :v-errors="errors" v-validate="local_metadata.bcicmretst.validator"
                v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.aicmretst" type="value" col="2" :metadata="local_metadata.aicmretst"
                :disabled="isView" name="aicmretst" :v-errors="errors" v-validate="local_metadata.aicmretst.validator"
                v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.vicmssubstituto" type="value" col="2" :metadata="local_metadata.vicmssubstituto"
                :disabled="isView" name="vicmssubstituto" :v-errors="errors"
                v-validate="local_metadata.vicmssubstituto.validator" v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.vicmretst" type="value" col="2" :metadata="local_metadata.vicmretst"
                :disabled="isView" name="vicmretst" :v-errors="errors" v-validate="local_metadata.vicmretst.validator"
                v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.vbcfcpstret" type="value" col="2" :metadata="local_metadata.vbcfcpstret"
                :disabled="isView" name="vbcfcpstret" :v-errors="errors"
                v-validate="local_metadata.vbcfcpstret.validator" v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.afcpretst" type="value" col="2" :metadata="local_metadata.afcpretst"
                :disabled="isView" name="afcpretst" :v-errors="errors" v-validate="local_metadata.afcpretst.validator"
                v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.vfcpretst" type="value" col="2" :metadata="local_metadata.vfcpretst"
                :disabled="isView" name="vfcpretst" :v-errors="errors" v-validate="local_metadata.vfcpretst.validator"
                v-if="icmsRetido"></form-field>
              <form-field v-model="nfit.cest" type="number" col="2" :metadata="local_metadata.cest" :disabled="isView"
                name="cest" :v-errors="errors" v-validate="local_metadata.cest.validator" v-if="icmsRetido">
              </form-field>
              <form-field v-model="nfit.motdesicm" type="select2" col="4" :metadata="local_metadata.motdesicm"
                :disabled="isView" parent="mymodal" name="motdesicm" :v-errors="errors"
                v-validate="local_metadata.motdesicm.validator" v-if="informaMotdes"></form-field>
              <form-field v-model="nfit.cbenef" type="text" col="4" :metadata="local_metadata.cbenef" :disabled="isView"
                name="cbenef" :v-errors="errors" v-validate="local_metadata.cbenef.validator">
              </form-field>

            </div>
          </div>

          <!-- "ICMS ST" -->
          <div v-if="tributadoIcmST">
            <div class="row">
              <form-field v-model="nfit.bcicmst" type="value" col="2" :metadata="local_metadata.bcicmst"
                :disabled="isView" name="bcicmst" :v-errors="errors" v-validate="local_metadata.bcicmst.validator"
                v-if="habilitaBCIcm"></form-field>
              <form-field v-model="nfit.ricmst" type="value" col="2" :metadata="local_metadata.ricmst"
                :disabled="isView" name="ricmst" :v-errors="errors" v-validate="local_metadata.ricmst.validator">
              </form-field>
              <form-field v-model="nfit.mva" type="value" col="2" :metadata="local_metadata.mva" :disabled="isView"
                name="mva" :v-errors="errors" v-validate="local_metadata.mva.validator"></form-field>
              <form-field v-model="nfit.aicmst" type="value" col="2" :metadata="local_metadata.aicmst"
                :disabled="isView" name="aicmst" :v-errors="errors" v-validate="local_metadata.aicmst.validator">
              </form-field>
              <form-field v-model="nfit.pautaicmst" type="value" col="2" :metadata="local_metadata.pautaicmst"
                :disabled="isView" name="pautaicmst" :v-errors="errors"
                v-validate="local_metadata.pautaicmst.validator"></form-field>
              <form-field v-model="nfit.vicmst" type="value" col="2" :metadata="local_metadata.vicmst"
                :disabled="isView" name="vicmst" :v-errors="errors" v-validate="local_metadata.vicmst.validator"
                v-if="params.nfComplementar"></form-field>
              <form-field v-model="nfit.afcpst" type="value" col="2" :metadata="local_metadata.afcpst"
                :disabled="isView" name="afcpst" :v-errors="errors" v-validate="local_metadata.afcpst.validator">
              </form-field>
              <form-field v-model="nfit.vfcpst" type="value" col="2" :metadata="local_metadata.vfcpst"
                :disabled="isView" name="vfcpst" :v-errors="errors" v-validate="local_metadata.vfcpst.validator"
                v-if="params.nfComplementar"></form-field>
              <form-field v-model="nfit.cest" type="number" col="2" :metadata="local_metadata.cest" :disabled="isView"
                name="cest" :v-errors="errors" v-validate="local_metadata.cest.validator" v-if="!icmsRetido">
              </form-field>
            </div>
          </div>

          <!-- DIFAL -->
          <div v-if="params.difal">
            <label-title title="DIFAL"></label-title>
            <div class="row">
              <form-field v-model="nfit.aicmdest" type="value" col="2" :metadata="local_metadata.aicmdest"
                :disabled="isView" name="aicmdest" :v-errors="errors" v-validate="local_metadata.aicmdest.validator">
              </form-field>
              <form-field v-model="nfit.afcpdest" type="value" col="2" :metadata="local_metadata.afcpdest"
                :disabled="isView" name="afcpdest" :v-errors="errors" v-validate="local_metadata.afcpdest.validator">
              </form-field>
              <form-field v-model="nfit.particmdest" type="value" col="2" :metadata="local_metadata.particmdest"
                :disabled="isView" name="particmdest" :v-errors="errors"
                v-validate="local_metadata.particmdest.validator"></form-field>
            </div>
          </div>


          <div>
            <label-title title="IPI"></label-title>
            <div class="row">
              <form-field v-if="params.nfsaida" v-model="nfit.stipi" type="select2" col="4"
                :metadata="local_metadata.stipi" :disabled="isView" name="stipi" :v-errors="errors"
                v-validate="local_metadata.stipi.validator" parent="mymodal"
                :select2="{ entity: 'stipi/saidas', minlength: 0 }"></form-field>
              <form-field v-if="!params.nfsaida" v-model="nfit.stipi" type="select2" col="4"
                :metadata="local_metadata.stipi" name="stipi" :v-errors="errors"
                v-validate="local_metadata.stipi.validator" parent="mymodal"
                :select2="{ entity: 'stipi/entradas', minlength: 0 }" :disabled="isView"></form-field>
              <form-field v-model="nfit.cenqipi" type="number" col="2" :metadata="local_metadata.cenqipi" name="cenqipi"
                :v-errors="errors" v-validate="local_metadata.cenqipi.validator" :disabled="isView"></form-field>
              <div class="w-100"></div>
              <form-field v-model="nfit.bcipi" type="value" col="2" :metadata="local_metadata.bcipi" :disabled="isView"
                name="bcipi" :v-errors="errors" v-validate="local_metadata.bcipi.validator"
                v-if="params.nfComplementar"></form-field>
              <form-field v-model="nfit.aipi" type="value" col="2" :metadata="local_metadata.aipi" :disabled="isView"
                name="aipi" :v-errors="errors" v-validate="local_metadata.aipi.validator" v-if="tributadoIpi">
              </form-field>
              <form-field v-model="nfit.pautaipi" type="value" col="2" :metadata="local_metadata.pautaipi"
                :disabled="isView" name="pautaipi" :v-errors="errors" v-validate="local_metadata.pautaipi.validator"
                v-if="tributadoIpi"></form-field>
              <form-field v-model="nfit.ripi" type="value" col="2" :metadata="local_metadata.ripi" :disabled="isView"
                name="ripi" :v-errors="errors" v-validate="local_metadata.ripi.validator" v-if="tributadoIpi">
              </form-field>
              <form-field v-model="nfit.vipi" type="value" col="2" :metadata="local_metadata.vipi" :disabled="isView"
                name="vipi" :v-errors="errors" v-validate="local_metadata.vipi.validator" v-if="params.nfComplementar">
              </form-field>
              <form-field v-model="nfit.pdevol" type="value" col="2" :metadata="local_metadata.pdevol"
                :disabled="isView || (nfit.codnfitorigem !== null && nfit.codnfitorigem !== undefined && nfit.codnfitorigem !== '')"
                name="pdevol" :v-errors="errors" v-validate="local_metadata.pdevol.validator" v-if="(params.ipidevol)">
              </form-field>
              <form-field v-model="nfit.vipidevol" type="value" col="2" :metadata="local_metadata.vipidevol"
                :disabled="isView || (nfit.codnfitorigem !== null && nfit.codnfitorigem !== undefined && nfit.codnfitorigem !== '')" name="vipidevol" :v-errors="errors" v-validate="local_metadata.vipidevol.validator"
                v-if="(params.ipidevol)"></form-field>
            </div>
          </div>

          <div>
            <label-title title="PIS/COFINS"></label-title>
            <div class="row">
              <form-field v-if="params.nfsaida" v-model="nfit.stpis" type="select2" col="4"
                :metadata="local_metadata.stpis" :disabled="isView" name="stpis" :v-errors="errors"
                v-validate="local_metadata.stpis.validator" parent="mymodal"
                :select2="{ entity: 'stpiscofins/saidas', minlength: 0 }"></form-field>
              <form-field v-if="!params.nfsaida" v-model="nfit.stpis" type="select2" col="4"
                :metadata="local_metadata.stpis" :disabled="isView" name="stpis" :v-errors="errors"
                v-validate="local_metadata.stpis.validator" parent="mymodal"
                :select2="{ entity: 'stpiscofins/entradas', minlength: 0 }"></form-field>
              <form-field v-model="nfit.bcpis" type="value" col="2" :metadata="local_metadata.bcpis" :disabled="isView"
                name="bcpis" :v-errors="errors" v-validate="local_metadata.bcpis.validator"
                v-if="params.nfComplementar"></form-field>
              <form-field v-model="nfit.apis" type="value" col="2" :metadata="local_metadata.apis" :disabled="isView"
                name="apis" :v-errors="errors" v-validate="local_metadata.apis.validator" v-if="tributadoPis">
              </form-field>
              <form-field v-model="nfit.pautapis" type="value" col="2" :metadata="local_metadata.pautapis"
                :disabled="isView" name="pautapis" :v-errors="errors" v-validate="local_metadata.pautapis.validator"
                v-if="pautaPis"></form-field>
              <form-field v-model="nfit.rpis" type="value" col="2" :metadata="local_metadata.rpis" :disabled="isView"
                name="rpis" :v-errors="errors" v-validate="local_metadata.rpis.validator" v-if="tributadoPis">
              </form-field>
              <form-field v-model="nfit.apisst" type="value" col="2" :metadata="local_metadata.apisst"
                :disabled="isView" name="apisst" :v-errors="errors" v-validate="local_metadata.apisst.validator"
                v-if="tributadoPisST"></form-field>
              <form-field v-model="nfit.pautapisst" type="value" col="2" :metadata="local_metadata.pautapisst"
                :disabled="isView" name="pautapisst" :v-errors="errors" v-validate="local_metadata.pautapisst.validator"
                v-if="tributadoPisST"></form-field>
              <form-field v-model="nfit.vpis" type="value" col="2" :metadata="local_metadata.vpis" :disabled="isView"
                name="vpis" :v-errors="errors" v-validate="local_metadata.vpis.validator" v-if="params.nfComplementar">
              </form-field>
            </div>
            <div class="row">
              <form-field v-if="params.nfsaida" v-model="nfit.stcofins" type="select2" col="4"
                :metadata="local_metadata.stcofins" :disabled="isView" name="stcofins" :v-errors="errors"
                v-validate="local_metadata.stcofins.validator" parent="mymodal"
                :select2="{ entity: 'stpiscofins/saidas', minlength: 0 }"></form-field>
              <form-field v-if="!params.nfsaida" v-model="nfit.stcofins" type="select2" col="4"
                :metadata="local_metadata.stcofins" :disabled="isView" name="stcofins" :v-errors="errors"
                v-validate="local_metadata.stcofins.validator" parent="mymodal"
                :select2="{ entity: 'stpiscofins/entradas', minlength: 0 }"></form-field>
              <form-field v-model="nfit.bccofins" type="value" col="2" :metadata="local_metadata.bccofins"
                :disabled="isView" name="bccofins" :v-errors="errors" v-validate="local_metadata.bccofins.validator"
                v-if="params.nfComplementar"></form-field>
              <form-field v-model="nfit.acofins" type="value" col="2" :metadata="local_metadata.acofins"
                :disabled="isView" name="acofins" :v-errors="errors" v-validate="local_metadata.acofins.validator"
                v-if="tributadoCofins"></form-field>
              <form-field v-model="nfit.pautacofins" type="value" col="2" :metadata="local_metadata.pautacofins"
                :disabled="isView" name="pautacofins" :v-errors="errors"
                v-validate="local_metadata.pautacofins.validator" v-if="pautaCofins"></form-field>
              <form-field v-model="nfit.rcofins" type="value" col="2" :metadata="local_metadata.rcofins"
                :disabled="isView" name="rcofins" :v-errors="errors" v-validate="local_metadata.rcofins.validator"
                v-if="tributadoCofins"></form-field>
              <form-field v-model="nfit.acofinsst" type="value" col="2" :metadata="local_metadata.acofinsst"
                :disabled="isView" name="acofinsst" :v-errors="errors" v-validate="local_metadata.acofinsst.validator"
                v-if="tributadoCofinsST"></form-field>
              <form-field v-model="nfit.pautacofinsst" type="value" col="2" :metadata="local_metadata.pautacofinsst"
                :disabled="isView" name="pautacofinsst" :v-errors="errors"
                v-validate="local_metadata.pautacofinsst.validator" v-if="tributadoCofinsST"></form-field>
              <form-field v-model="nfit.vcofins" type="value" col="2" :metadata="local_metadata.vcofins"
                :disabled="isView" name="vcofins" :v-errors="errors" v-validate="local_metadata.vcofins.validator"
                v-if="params.nfComplementar"></form-field>
            </div>
          </div>
        </div>


          <div>
            <div v-if="!showIBSCBS && !isView" class="mt-2 mb-2">
              <a href="javascript:void(0);" :tabindex="1" @click="showIBSCBS = true"><i class="fa fa-caret-down"
                  aria-hidden="true"></i> Exibir Nova Tributação(IS,IBS,CBS)</a>
            </div>
            <div class="my-2" v-if="showIBSCBS || isView">
              <label-title title="Impostos Unificados (IBS e CBS)"></label-title>
              <div class="row">
                <form-field v-model="nfit.ibscbscclass" type="select2" col="4" :metadata="local_metadata.ibscbscclass"
                  :disabled="isView" name="ibscbscclass" :v-errors="errors"
                  v-validate="local_metadata.ibscbscclass.validator" parent="mymodal"
                  :select2="{ entity: 'ivaclass', minlength: 0 }"></form-field>

                <!--
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.ibscbsinddoacao"
                  type="select" col="4" :metadata="local_metadata.ibscbsinddoacao" :disabled="isView"
                  name="ibscbsinddoacao" :v-errors="errors" v-validate="local_metadata.ibscbsinddoacao.validator">
                </form-field>
                -->
              </div>
              <label-title v-if="ivaclass.ind_gibscbs == 1" title="IBS UF"></label-title>
              <div v-if="ivaclass.ind_gibscbs == 1" class="row">
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.ibsufaliq" type="value" col="4"
                  :metadata="local_metadata.ibsufaliq" :disabled="isView" name="ibsufaliq" :v-errors="errors"
                  v-validate="local_metadata.ibsufaliq.validator"></form-field>

                <!--
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.ibsufvlr" type="value"
                  col="2" :metadata="local_metadata.ibsufvlr" :disabled="isView" name="ibsufvlr" :v-errors="errors"
                  v-validate="local_metadata.ibsufvlr.validator">
                </form-field>
                -->
                <form-field v-if="ivaclass.ind_gdif == 1" v-model="nfit.ibsufpdif" type="value" col="4"
                  :metadata="local_metadata.ibsufpdif" :disabled="isView" name="ibsufpdif" :v-errors="errors"
                  v-validate="local_metadata.ibsufpdif.validator"></form-field>

                <!--
                <form-field v-if="ivaclass.ind_gdif == 1" v-model="nfit.ibsufvdif" type="value"
                  col="2" :metadata="local_metadata.ibsufvdif" :disabled="isView" name="ibsufvdif" :v-errors="errors"
                  v-validate="local_metadata.ibsufvdif.validator"></form-field>
                -->
                <form-field v-if="ivaclass.ind_gred == 1" v-model="nfit.ibsufred" type="value" col="4"
                  :metadata="local_metadata.ibsufred" :disabled="isView" name="ibsufred" :v-errors="errors"
                  v-validate="local_metadata.ibsufred.validator">
                </form-field>

                <!--
                <form-field v-if="ivaclass.ind_gred == 1" v-model="nfit.ibsufpefet" type="value"
                  col="2" :metadata="local_metadata.ibsufpefet" :disabled="isView" name="ibsufpefet" :v-errors="errors"
                  v-validate="local_metadata.ibsufpefet.validator"></form-field>
                -->
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.ibsufvdevtrib" type="value" col="4"
                  :metadata="local_metadata.ibsufvdevtrib" :disabled="isView" name="ibsufvdevtrib" :v-errors="errors"
                  v-validate="local_metadata.ibsufvdevtrib.validator"></form-field>
              </div>

              <label-title v-if="ivaclass.ind_gibscbs == 1" title="IBS Município"></label-title>
              <div v-if="ivaclass.ind_gibscbs == 1" class="row">
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.ibsmunaliq" type="value" col="4"
                  :metadata="local_metadata.ibsmunaliq" :disabled="isView" name="ibsmunaliq" :v-errors="errors"
                  v-validate="local_metadata.ibsmunaliq.validator"></form-field>

                <form-field v-if="ivaclass.ind_gdif == 1" v-model="nfit.ibsmunpdif" type="value" col="4"
                  :metadata="local_metadata.ibsmunpdif" :disabled="isView" name="ibsmunpdif" :v-errors="errors"
                  v-validate="local_metadata.ibsmunpdif.validator"></form-field>

                <form-field v-if="ivaclass.ind_gred == 1" v-model="nfit.ibsmunred" type="value" col="4"
                  :metadata="local_metadata.ibsmunred" :disabled="isView" name="ibsmunred" :v-errors="errors"
                  v-validate="local_metadata.ibsmunred.validator"></form-field>

                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.ibsmunvdevtrib" type="value" col="4"
                  :metadata="local_metadata.ibsmunvdevtrib" :disabled="isView" name="ibsmunvdevtrib" :v-errors="errors"
                  v-validate="local_metadata.ibsmunvdevtrib.validator">
                </form-field>
              </div>

              <label-title v-if="ivaclass.ind_gibscbs == 1" title="CBS"></label-title>
              <div v-if="ivaclass.ind_gibscbs == 1" class="row">
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.cbsaliq" type="value" col="4"
                  :metadata="local_metadata.cbsaliq" :disabled="isView" name="cbsaliq" :v-errors="errors"
                  v-validate="local_metadata.cbsaliq.validator">
                </form-field>

                <!--
                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.cbsvlr" type="value"
                  col="2" :metadata="local_metadata.cbsvlr" :disabled="isView" name="cbsvlr" :v-errors="errors"
                  v-validate="local_metadata.cbsvlr.validator">
                </form-field>
                -->
                <form-field v-if="ivaclass.ind_gdif == 1" v-model="nfit.cbspdif" type="value" col="4"
                  :metadata="local_metadata.cbspdif" :disabled="isView" name="cbspdif" :v-errors="errors"
                  v-validate="local_metadata.cbspdif.validator">
                </form-field>

                <!--
                <form-field v-if="ivaclass.ind_gdif == 1" v-model="nfit.cbsvdif" type="value" col="2"
                  :metadata="local_metadata.cbsvdif" :disabled="isView" name="cbsvdif" :v-errors="errors"
                  v-validate="local_metadata.cbsvdif.validator">
                </form-field>
                -->

                <form-field v-if="ivaclass.ind_gred == 1" v-model="nfit.cbsred" type="value" col="4"
                  :metadata="local_metadata.cbsred" :disabled="isView" name="cbsred" :v-errors="errors"
                  v-validate="local_metadata.cbsred.validator">
                </form-field>

                <!--
                <form-field v-if="ivaclass.ind_gred == 1" v-model="nfit.cbspefet" type="value" col="2"
                  :metadata="local_metadata.cbspefet" :disabled="isView" name="cbspefet" :v-errors="errors"
                  v-validate="local_metadata.cbspefet.validator">
                </form-field>
                -->

                <form-field v-if="ivaclass.ind_gibscbs == 1" v-model="nfit.cbsvdevtrib" type="value" col="4"
                  :metadata="local_metadata.cbsvdevtrib" :disabled="isView" name="cbsvdevtrib" :v-errors="errors"
                  v-validate="local_metadata.cbsvdevtrib.validator"></form-field>
              </div>
              <!--
              <label-title title="Imposto Seletivo"></label-title>
              <div class="row">
                <form-field v-model="nfit.isbc" type="value" col="2" :metadata="local_metadata.isbc" :disabled="isView"
                  name="isbc" :v-errors="errors" v-validate="local_metadata.isbc.validator"></form-field>
                <form-field v-model="nfit.isaliq" type="value" col="2" :metadata="local_metadata.isaliq"
                  :disabled="isView" name="isaliq" :v-errors="errors" v-validate="local_metadata.isaliq.validator">
                </form-field>
                <form-field v-model="nfit.isvlr" type="value" col="2" :metadata="local_metadata.isvlr"
                  :disabled="isView" name="isvlr" :v-errors="errors" v-validate="local_metadata.isvlr.validator">
                </form-field>
                <form-field v-model="nfit.isespec" type="value" col="2" :metadata="local_metadata.isespec"
                  :disabled="isView" name="isespec" :v-errors="errors" v-validate="local_metadata.isespec.validator">
                </form-field>
                <form-field v-model="nfit.isqtrib" type="value" col="2" :metadata="local_metadata.isqtrib"
                  :disabled="isView" name="isqtrib" :v-errors="errors" v-validate="local_metadata.isqtrib.validator">
                </form-field>
              </div>
              -->
              <label-title v-if="ivaclass.gtribregular == 1" title="Grupo de Tributação Regular">
              </label-title>
              <div v-if="ivaclass.gtribregular == 1" class="row">
                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.ibscbsregcclass" type="select2" col="4"
                  :metadata="local_metadata.ibscbsregcclass" :disabled="isView" name="ibscbsregcclass"
                  :v-errors="errors" v-validate="local_metadata.ibscbsregcclass.validator" parent="mymodal"
                  :select2="{ entity: 'ivaclass', minlength: 0 }"></form-field>
                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.ibsufregaliq" type="value" col="4"
                  :metadata="local_metadata.ibsufregaliq" :disabled="isView" name="ibsufregaliq" :v-errors="errors"
                  v-validate="local_metadata.ibsufregaliq.validator"></form-field>

                <!--
                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.ibsufregvlr" type="value"
                  col="2" :metadata="local_metadata.ibsufregvlr" :disabled="isView" name="ibsufregvlr"
                  :v-errors="errors" v-validate="local_metadata.ibsufregvlr.validator"></form-field>
                -->
                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.ibsmunregaliq" type="value" col="4"
                  :metadata="local_metadata.ibsmunregaliq" :disabled="isView" name="ibsmunregaliq" :v-errors="errors"
                  v-validate="local_metadata.ibsmunregaliq.validator"></form-field>

                <!--
                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.ibsmunregvlr" type="value"
                  col="2" :metadata="local_metadata.ibsmunregvlr" :disabled="isView" name="ibsmunregvlr"
                  :v-errors="errors" v-validate="local_metadata.ibsmunregvlr.validator"></form-field>
                -->

                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.cbsregaliq" type="value" col="4"
                  :metadata="local_metadata.cbsregaliq" :disabled="isView" name="cbsregaliq" :v-errors="errors"
                  v-validate="local_metadata.cbsregaliq.validator"></form-field>

                <!--
                <form-field v-if="ivaclass.gtribregular == 1" v-model="nfit.cbsregvlr" type="value"
                  col="2" :metadata="local_metadata.cbsregvlr" :disabled="isView" name="cbsregvlr" :v-errors="errors"
                  v-validate="local_metadata.cbsregvlr.validator"></form-field>

                -->
              </div>

              <!--
              <label-title  title="Compras Governamentais">
              </label-title>
              <div  class="row">
                <form-field v-model="nfit.ibsufacompgov" type="value" col="4"
                  :metadata="local_metadata.ibsufacompgov" :disabled="isView" name="ibsufacompgov" :v-errors="errors"
                  v-validate="local_metadata.ibsufacompgov.validator"></form-field>
                <form-field v-model="nfit.ibsmunacompgov" type="value" col="4"
                  :metadata="local_metadata.ibsmunacompgov" :disabled="isView" name="ibsmunacompgov" :v-errors="errors"
                  v-validate="local_metadata.ibsmunacompgov.validator"></form-field>
                <form-field v-model="nfit.cbsacompgov" type="value" col="4"
                  :metadata="local_metadata.cbsacompgov" :disabled="isView" name="cbsacompgov" :v-errors="errors"
                  v-validate="local_metadata.cbsacompgov.validator"></form-field>
              </div>
                -->

              <label-title v-if="ivaclass.ind_gibscbsmono == 1" title="Regime Monofásico">
              </label-title>
              <div v-if="ivaclass.ind_gibscbsmono == 1" class="row">
                <form-field v-if="ivaclass.mono == 1" v-model="nfit.qbcmono" type="value" col="4"
                  :metadata="local_metadata.qbcmono" :disabled="isView" name="qbcmono" :v-errors="errors"
                  v-validate="local_metadata.qbcmono.validator">
                </form-field>
                <form-field v-if="ivaclass.mono == 1" v-model="nfit.ibsamono" type="value" col="4"
                  :metadata="local_metadata.ibsamono" :disabled="isView" name="ibsamono" :v-errors="errors"
                  v-validate="local_metadata.ibsamono.validator">
                </form-field>
                <form-field v-if="ivaclass.mono == 1" v-model="nfit.ibsvmono" type="value" col="4"
                  :metadata="local_metadata.ibsvmono" :disabled="isView" name="ibsvmono" :v-errors="errors"
                  v-validate="local_metadata.ibsvmono.validator">
                </form-field>
                <form-field v-if="ivaclass.mono == 1" v-model="nfit.cbsamono" type="value" col="4"
                  :metadata="local_metadata.cbsamono" :disabled="isView" name="cbsamono" :v-errors="errors"
                  v-validate="local_metadata.cbsamono.validator">
                </form-field>
                <form-field v-if="ivaclass.mono == 1" v-model="nfit.cbsvmono" type="value" col="4"
                  :metadata="local_metadata.cbsvmono" :disabled="isView" name="cbsvmono" :v-errors="errors"
                  v-validate="local_metadata.cbsvmono.validator">
                </form-field>

                <form-field v-if="ivaclass.monoret == 1" v-model="nfit.qbcmonoret" type="value" col="4"
                  :metadata="local_metadata.qbcmonoret" :disabled="isView" name="qbcmonoret" :v-errors="errors"
                  v-validate="local_metadata.qbcmonoret.validator"></form-field>
                <form-field v-if="ivaclass.monoret == 1" v-model="nfit.ibsamonoret" type="value" col="4"
                  :metadata="local_metadata.ibsamonoret" :disabled="isView" name="ibsamonoret" :v-errors="errors"
                  v-validate="local_metadata.ibsamonoret.validator"></form-field>
                <form-field v-if="ivaclass.monoret == 1" v-model="nfit.ibsvmonoret" type="value" col="4"
                  :metadata="local_metadata.ibsvmonoret" :disabled="isView" name="ibsvmonoret" :v-errors="errors"
                  v-validate="local_metadata.ibsvmonoret.validator"></form-field>
                <form-field v-if="ivaclass.monoret == 1" v-model="nfit.cbsamonoret" type="value" col="4"
                  :metadata="local_metadata.cbsamonoret" :disabled="isView" name="cbsamonoret" :v-errors="errors"
                  v-validate="local_metadata.cbsamonoret.validator"></form-field>
                <form-field v-if="ivaclass.monoret == 1" v-model="nfit.cbsvmonoret" type="value" col="4"
                  :metadata="local_metadata.cbsvmonoret" :disabled="isView" name="cbsvmonoret" :v-errors="errors"
                  v-validate="local_metadata.cbsvmonoret.validator"></form-field>

                <form-field v-if="ivaclass.monoreten == 1" v-model="nfit.qbcmonoreten" type="value" col="4"
                  :metadata="local_metadata.qbcmonoreten" :disabled="isView" name="qbcmonoreten" :v-errors="errors"
                  v-validate="local_metadata.qbcmonoreten.validator"></form-field>
                <form-field v-if="ivaclass.monoreten == 1" v-model="nfit.ibsamonoreten" type="value" col="4"
                  :metadata="local_metadata.ibsamonoreten" :disabled="isView" name="ibsamonoreten" :v-errors="errors"
                  v-validate="local_metadata.ibsamonoreten.validator"></form-field>
                <form-field v-if="ivaclass.monoreten == 1" v-model="nfit.ibsvmonoreten" type="value" col="4"
                  :metadata="local_metadata.ibsvmonoreten" :disabled="isView" name="ibsvmonoreten" :v-errors="errors"
                  v-validate="local_metadata.ibsvmonoreten.validator"></form-field>
                <form-field v-if="ivaclass.monoreten == 1" v-model="nfit.cbsamonoreten" type="value" col="4"
                  :metadata="local_metadata.cbsamonoreten" :disabled="isView" name="cbsamonoreten" :v-errors="errors"
                  v-validate="local_metadata.cbsamonoreten.validator"></form-field>
                <form-field v-if="ivaclass.monoreten == 1" v-model="nfit.cbsvmonoreten" type="value" col="4"
                  :metadata="local_metadata.cbsvmonoreten" :disabled="isView" name="cbsvmonoreten" :v-errors="errors"
                  v-validate="local_metadata.cbsvmonoreten.validator"></form-field>

                <form-field v-if="ivaclass.monodif == 1" v-model="nfit.ibsamonodif" type="value" col="4"
                  :metadata="local_metadata.ibsamonodif" :disabled="isView" name="ibsamonodif" :v-errors="errors"
                  v-validate="local_metadata.ibsamonodif.validator"></form-field>
                <form-field v-if="ivaclass.monodif == 1" v-model="nfit.cbsamonodif" type="value" col="4"
                  :metadata="local_metadata.cbsamonodif" :disabled="isView" name="cbsamonodif" :v-errors="errors"
                  v-validate="local_metadata.cbsamonodif.validator"></form-field>
                <form-field v-if="ivaclass.monodif == 1" v-model="nfit.ibsvmonodif" type="value" col="4"
                  :metadata="local_metadata.ibsvmonodif" :disabled="isView" name="ibsvmonodif" :v-errors="errors"
                  v-validate="local_metadata.ibsvmonodif.validator"></form-field>
                <form-field v-if="ivaclass.monodif == 1" v-model="nfit.cbsvmonodif" type="value" col="4"
                  :metadata="local_metadata.cbsvmonodif" :disabled="isView" name="cbsvmonodif" :v-errors="errors"
                  v-validate="local_metadata.cbsvmonodif.validator"></form-field>
              </div>

              <label-title v-if="ivaclass.ind_gtransfcred == 1" title="Transferência de Crédito">
              </label-title>
              <div v-if="ivaclass.ind_gtransfcred == 1" class="row">
                <form-field v-if="ivaclass.ind_gtransfcred == 1" v-model="nfit.vibstransf" type="value" col="4"
                  :metadata="local_metadata.vibstransf" :disabled="isView" name="vibstransf" :v-errors="errors"
                  v-validate="local_metadata.vibstransf.validator"></form-field>
                <form-field v-if="ivaclass.ind_gtransfcred == 1" v-model="nfit.vcbstransf" type="value" col="4"
                  :metadata="local_metadata.vcbstransf" :disabled="isView" name="vcbstransf" :v-errors="errors"
                  v-validate="local_metadata.vcbstransf.validator"></form-field>
              </div>

              <label-title v-if="ivaclass.estornocred == 1" title="Estorno de Crédito">
              </label-title>
              <div v-if="ivaclass.estornocred == 1" class="row">
                <form-field v-model="nfit.estcredvibs" type="value" col="4" :metadata="local_metadata.estcredvibs"
                  :disabled="isView" name="estcredvibs" :v-errors="errors"
                  v-validate="local_metadata.estcredvibs.validator"></form-field>
                <form-field v-model="nfit.estcredvcbs" type="value" col="4" :metadata="local_metadata.estcredvcbs"
                  :disabled="isView" name="estcredvcbs" :v-errors="errors"
                  v-validate="local_metadata.estcredvcbs.validator"></form-field>
              </div>

              <label-title v-if="ivaclass.ind_gajustecompet == 1" title="Ajuste de Competência">
              </label-title>
              <div v-if="ivaclass.ind_gajustecompet == 1" class="row">
                <form-field v-if="ivaclass.ind_gajustecompet == 1" v-model="nfit.ajustecompetapur" type="text" col="4"
                  :metadata="local_metadata.ajustecompetapur" :disabled="isView" name="ajustecompetapur"
                  :v-errors="errors" v-validate="local_metadata.ajustecompetapur.validator">
                </form-field>
                <form-field v-if="ivaclass.ind_gajustecompet == 1" v-model="nfit.ajustecompetvibs" type="value" col="4"
                  :metadata="local_metadata.ajustecompetvibs" :disabled="isView" name="ajustecompetvibs"
                  :v-errors="errors" v-validate="local_metadata.ajustecompetvibs.validator">
                </form-field>
                <form-field v-if="ivaclass.ind_gajustecompet == 1" v-model="nfit.ajustecompetvcbs" type="value" col="4"
                  :metadata="local_metadata.ajustecompetvcbs" :disabled="isView" name="ajustecompetvcbs"
                  :v-errors="errors" v-validate="local_metadata.ajustecompetvcbs.validator">
                </form-field>
              </div>

              <label-title v-if="ivaclass.credpres == 1" title="Crédito Presumido">
              </label-title>
              <div v-if="ivaclass.credpres == 1" class="row">
                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.credpresvbc" type="value" col="4"
                  :metadata="local_metadata.credpresvbc" :disabled="isView" name="credpresvbc" :v-errors="errors"
                  v-validate="local_metadata.credpresvbc.validator"></form-field>
                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.ccredpres" type="select" col="4"
                  :metadata="local_metadata.ccredpres" :disabled="isView" name="ccredpres" :v-errors="errors"
                  v-validate="local_metadata.ccredpres.validator"></form-field>

              </div>

              <label-title v-if="ivaclass.credpres == 1" title="Crédito Presumido (IBS)">
              </label-title>
              <div v-if="ivaclass.credpres == 1" class="row">
                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.ibspcredpres" type="value" col="4"
                  :metadata="local_metadata.ibspcredpres" :disabled="isView" name="ibspcredpres" :v-errors="errors"
                  v-validate="local_metadata.ibspcredpres.validator"></form-field>

                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.ibsvcredpres" type="value" col="2"
                  :metadata="local_metadata.ibsvcredpres" :disabled="isView" name="ibsvcredpres" :v-errors="errors"
                  v-validate="local_metadata.ibsvcredpres.validator"></form-field>

                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.ibsvcredprescondsus" type="value" col="4"
                  :metadata="local_metadata.ibsvcredprescondsus" :disabled="isView" name="ibsvcredprescondsus"
                  :v-errors="errors" v-validate="local_metadata.ibsvcredprescondsus.validator"></form-field>

              </div>
              <label-title v-if="ivaclass.credpres == 1" title="Crédito Presumido (CBS)">
              </label-title>
              <div v-if="ivaclass.credpres == 1" class="row">
                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.cbspcredpres" type="value" col="4"
                  :metadata="local_metadata.cbspcredpres" :disabled="isView" name="cbspcredpres" :v-errors="errors"
                  v-validate="local_metadata.cbspcredpres.validator"></form-field>

                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.cbsvcredpres" type="value" col="2"
                  :metadata="local_metadata.cbsvcredpres" :disabled="isView" name="cbsvcredpres" :v-errors="errors"
                  v-validate="local_metadata.cbsvcredpres.validator"></form-field>

                <form-field v-if="ivaclass.credpres == 1" v-model="nfit.cbsvcredprescondsus" type="value" col="4"
                  :metadata="local_metadata.cbsvcredprescondsus" :disabled="isView" name="cbsvcredprescondsus"
                  :v-errors="errors" v-validate="local_metadata.cbsvcredprescondsus.validator"></form-field>
              </div>

              <label-title v-if="ivaclass.ind_gcredpresibszfm == 1" title="Crédito presumido ZFM">
              </label-title>
              <div v-if="ivaclass.ind_gcredpresibszfm == 1" class="row">
                <form-field v-model="nfit.ibszfmcredpresapur" type="text" col="4"
                  :metadata="local_metadata.ibszfmcredpresapur" :disabled="isView" name="ibszfmcredpresapur"
                  :v-errors="errors" v-validate="local_metadata.ibszfmcredpresapur.validator"></form-field>
                <form-field v-model="nfit.ibszfmtpcredpres" type="select" col="4"
                  :metadata="local_metadata.ibszfmtpcredpres" :disabled="isView" name="ibszfmtpcredpres"
                  :v-errors="errors" v-validate="local_metadata.ibszfmtpcredpres.validator"></form-field>
                <form-field v-model="nfit.ibszfmvcredpres" type="value" col="4"
                  :metadata="local_metadata.ibszfmvcredpres" :disabled="isView" name="ibszfmvcredpres"
                  :v-errors="errors" v-validate="local_metadata.ibszfmvcredpres.validator"></form-field>
              </div>

            </div>
          </div>
          <!-- obervacoes -->
          <label-title title="Outros Dados"></label-title>
          <div class="row" v-if="nfImportacao">
            <form-field v-model="nfit.nadicao" type="value" col="2" :metadata="local_metadata.nadicao"
              :disabled="isView" name="nadicao" :v-errors="errors" v-validate="local_metadata.nadicao.validator">
            </form-field>
            <form-field v-model="nfit.itadicao" type="value" col="2" :metadata="local_metadata.itadicao"
              :disabled="isView" name="itadicao" :v-errors="errors" v-validate="local_metadata.itadicao.validator">
            </form-field>
          </div>
          <div class="row">
            <form-field v-model="nfit.pedcliit" type="value" col="2" :metadata="local_metadata.pedcliit"
              :disabled="isView" name="pedcliit" :v-errors="errors" v-validate="local_metadata.pedcliit.validator">
            </form-field>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="form-group">
                <v-label :metadata-field="local_metadata.obs"></v-label>
                <textarea rows="4" cols="100" class="form-control form-control-sm" :disabled="isView" name="desccomp"
                  v-model="nfit.obs" v-validate="{}"></textarea>
              </div>
            </div>
          </div>
          </div>

          <!-- Vínculo de Origem (Grupo DFeReferenciado) -->
          <div class="mb-3" v-show="activeTab === 1">
            <div class="row" v-if="!params.habilitaItem">
              <div class="col-md-3 col-1">
                <span class="lbl-title-produto w-100">{{ nfit.item[0].descricao }}</span>
                <span class="data-list w-100">{{ nfit.item[0].codigo }}</span>
              </div>
              <div class="col-md-1 col-2" align="center">
                <span class="lbl-title-produto w-100">{{ this.local_metadata.uni.label }}</span>
                <span class="data-list w-100">{{ this.nfit.uni }}</span>
              </div>
              <div class="col-md-2 col-3" align="right">
                <span class="lbl-title-produto w-100">{{ this.local_metadata.qtuni.label }}</span>
                <span class="data-list w-100">{{ this.nfit.qtuni | formatValue(2) }}</span>
              </div>
              <div class="col-md-2 col-4" align="right">
                <span class="lbl-title-produto w-100">{{ this.local_metadata.vlr.label }}</span>
                <span class="data-list w-100">{{ this.nfit.vlr | formatValue(2) }}</span>
              </div>
              <div class="col-md-2 col-5" align="right">
                <span class="lbl-title-produto w-100">{{ this.local_metadata.totliq.label }}</span>
                <span class="data-list w-100">{{ this.nfit.totliq | formatValue(2) }}</span>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-12 d-flex justify-content-between align-items-center">
                <label-title title="Vínculo de Origem do item da Nota (DFe Referenciado)"></label-title>
                <button type="button" class="btn btn-sm btn-danger" @click="limparVinculoOrigem" :disabled="isView">
                  <i class="fa fa-trash"></i> Limpar Vínculo
                </button>
              </div>
            </div>

            <tabs :tabs="subTabs" :setActiveTab="activeSubTab" @onClickTab="changeSubTab" class="mb-4"></tabs>

            <!-- Nota do Sistema -->
            <div v-show="activeSubTab === 0">

              <div class="row mt-3" v-if="nfOrigemDados || nfitemOrigemDados">
                <div class="col-12">
                  <div class="card bg-light p-3" style="border-radius: 5px; border: 1px solid #e3e6f0;">
                    <div class="row">
                      <div class="col-md-6 col-12" v-if="nfOrigemDados">
                        <h6 class="text-primary font-weight-bold mb-2"><i class="fa fa-file-text-o"></i> Nota de Origem</h6>
                        <ul class="list-unstyled mb-0" style="padding-left: 0;">
                          <li><strong>Nº da Nota:</strong> {{ nfOrigemDados.numnf }}</li>
                          <li><strong>Série:</strong> {{ nfOrigemDados.serie }}</li>
                          <li class="text-truncate" :title="nfOrigemDados.chave"><strong>Chave:</strong> {{ nfOrigemDados.chave }}</li>
                        </ul>
                      </div>
                      <div class="col-md-6 col-12" v-if="nfitemOrigemDados">
                        <h6 class="text-primary font-weight-bold mb-2"><i class="fa fa-cube"></i> Item de Origem</h6>
                        <ul class="list-unstyled mb-0" style="padding-left: 0;">
                          <li><strong>Descrição:</strong> {{ nfitemOrigemDados.descricao }}</li>
                          <li><strong>Quantidade:</strong> {{ nfitemOrigemDados.quantidade | formatValue(2) }}</li>
                          <li><strong>Valor Unitário:</strong> R$ {{ nfitemOrigemDados.valor | formatValue(2) }}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-3" v-else>
                <div class="col-12">
                  <div class="alert alert-info mb-0">
                    <i class="fa fa-info-circle"></i> Nenhum vínculo com documento do sistema identificado para este item.
                  </div>
                </div>
              </div>
            </div>

            <!-- Carregar XML -->
            <div v-show="activeSubTab === 1">
              <div class="row">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="control-label">Carregar Arquivo XML</label>
                    <input type="file" accept=".xml" class="form-control form-control-sm" :disabled="isView" @change="onXMLFileSelected" />
                  </div>
                </div>
                <form-field v-if="xmlParsedData" v-model="nfit.nitemorigem" type="select" col="6" :metadata="local_metadata.xmlSelectedItem" :disabled="isView" :select-options="xmlSelectOptions" @input="selecionarItemXmlByValue"></form-field>
              </div>
              <div class="row" v-if="nfit.chaveorigem">
                <div class="col-md-12">
                  <p class="text-success mt-2" style="font-weight: bold;">
                    <i class="fa fa-check-circle"></i> Chave Vinculada: {{ nfit.chaveorigem }} (Item: {{ nfit.nitemorigem }})
                  </p>
                </div>
              </div>
            </div>

            <!-- Digitação Manual -->
            <div v-show="activeSubTab === 2">
              <div class="row">
                <form-field v-model="nfit.chaveorigem" type="text" col="9" :metadata="local_metadata.chaveorigem" :disabled="isView" name="chaveorigem" :v-errors="errors" v-validate="local_metadata.chaveorigem.validator" maxlength="44" placeholder="00000000000000000000000000000000000000000000"></form-field>
                <form-field v-model="nfit.nitemorigem" type="number" col="3" :metadata="local_metadata.nitemorigem" :disabled="isView" name="nitemorigem" :v-errors="errors" v-validate="local_metadata.nitemorigem.validator" min="1" placeholder="1"></form-field>
              </div>
            </div>
          </div>

          <div class="nb-modal-scrollable-footer">
            <v-button v-if="!isView" ref="btnConfirmBottom" label="Salvar (F9)" :nb-btdef="true" @click="handleValidarItem"></v-button>
            <v-button ref="btnCloseBottom" label="Cancelar" @click="closeForm"></v-button>
          </div>
        </div>
      </div>
    </div>

    <div class="nb-modal-scrollable" v-if="showItemForm">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <item-form :crud="crud" :descricao="descricaoNovoItem" @closeform="closeItemForm"></item-form>
          </div>
        </div>
      </Trap>
    </div>

  </transition>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/nfsaida-item.vue